import { FilterRadioButtonInterface } from './interface';
import { SecondaryButton } from './styles';

export default function FilterRadioButton({
  children, onClick, selected, invisible, sameWidth, nowrap, disabled, height
}:  FilterRadioButtonInterface) {
  return (
    <SecondaryButton
      onClick={onClick}
      selected={selected}
      invisible={invisible}
      sameWidth={sameWidth}
      nowrap={nowrap}
      disabled={disabled}
      height={height}
    >
      {children}
    </SecondaryButton>
  );
}
